module.exports = __webpack_public_path__ + "static/img/wall-outlet-mk-3_256.8e090a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-outlet-mk-3_256.png
// module id = Yfbb
// module chunks = 0